function NotFound() {
    return <>Not found</>;
}

export default NotFound;
